/* eslint-disable */
const ontology = [
  {
    id: 'CI',
    label: 'Cultura e identidad',
    children: [
      {
        id: 'GI',
        label: 'Grupos Indígenas',
        children: [
          {
            id: 'DIA',
            label: 'Derechos de los indígenas a autogobierno'
          },
          {
            id: 'DINPI',
            label: 'Derechos de los indígenas a no pagar impuestos'
          },
          {
            id: 'DIR',
            label: 'Derechos de los indígenas a ser representados'
          },
          {
            id: 'DIPP',
            label: 'Derechos de indígenas a partidos políticos'
          },
          {
            id: 'DIV',
            label: 'Derechos de los indígenas al voto'
          },
          {
            id: 'NGI',
            label: 'Nacionalidad de los grupos indígenas'
          }
        ]
      },
      {
        id: 'IDIOM',
        label: 'Idioma',
        children: [
          {
            id: 'DAJIN',
            label: 'Derecho del acusado a ser juzgado en su idioma nativo'
          },
          {
            id: 'IO-N',
            label: 'Idiomas oficiales o nacionales'
          },
          {
            id: 'ISDI',
            label: 'Igualdad sin distinción de idioma'
          },
          {
            id: 'PUI',
            label: 'Protección del uso del idioma'
          }
        ]
      },
      {
        id: 'NAC',
        label: 'Nacionalidad',
        children: [
          {
            id: 'CRC',
            label: 'Condiciones para revocar la ciudadanía'
          },
          {
            id: 'DRC',
            label: 'Derecho de renunciar a la ciudadanía'
          },
          {
            id: 'FDC',
            label: 'Facultad para deportar a ciudadanos'
          },
          {
            id: 'ISDN',
            label: 'Igualdad sin distinción de nacionalidad'
          },
          {
            id: 'ISDO',
            label: 'Igualdad sin distinción de origen'
          },
          {
            id: 'N-GI',
            label: 'Nacionalidad de los grupos indígenas'
          },
          {
            id: 'RN',
            label: 'Requisitos para nacionalización'
          },
          {
            id: 'RNN',
            label: 'Requisitos para obtener nacionalidad por nacimiento'
          },
          {
            id: 'RES',
            label: 'Restricciones de entrada y salida'
          }
        ]
      },
      {
        id: 'R-E',
        label: 'Raza y etnicidad',
        children: [
          {
            id: 'ISDR',
            label: 'Igualdad sin distinción de raza'
          },
          {
            id: 'ISDTC',
            label: 'Igualdad sin distinción de tribu o clan'
          },
          {
            id: 'ICF',
            label: 'Integración de comunidades étnicas'
          },
          {
            id: 'RR',
            label: 'Redistribución de la riqueza'
          } 
        ]
      },
      {
        id: 'RELIG',
        label: 'Religión',
        children: [
          {
            id: 'DOD',
            label: 'Dios u otras deidades'
          },
          {
            id: 'ETE',
            label: 'Establecimiento de tribunales eclesiásticos'
          },
          {
            id: 'EDC',
            label: 'Estatus del derecho canónico (religioso)'
          },
          {
            id: 'EFOR',
            label: 'Estatus fiscal de organizaciones religiosas'
          },
          {
            id: 'IDFC',
            label: 'Igualdad sin distinción de fe o creencias'
          },
          {
            id: 'ISDRELIG',
            label: 'Igualdad sin distinción de religión'
          },
          {
            id: 'LR',
            label: 'Libertad religiosa'
          },
          {
            id: 'RO',
            label: 'Religión oficial'
          },
          {
            id: 'SIE',
            label: 'Separación de iglesia y Estado'
          } 
        ]
      }
    ]
  },
  {
    id: 'DEB-DER',
    label: 'Deberes y derechos',
    children: [
      {
        id: 'DC',
        label: 'Deberes ciudadanos',
        children: [
          {
            id: 'OPI',
            label: 'Obligación de pagar impuestos'
          },
          {
            id: 'OT',
            label: 'Obligación de trabajar'
          },
          {
            id: 'SM',
            label: 'Servicio militar'
          },
          {
            id: 'DRDO',
            label: 'Deber de Respeto de los derechos de otros'
          },
          {
            id: 'DEL-NAD',
            label: 'Deber de Ejercicio legítimo y no abusivo de los derechos'
          },
          {
            id: 'DSC',
            label: 'Deber de Servicio a la comunidad '
          },
          {
            id: 'DABC',
            label: 'Deber de actuar por el bien común'
          },
          {
            id: 'DBI',
            label: 'Deber de estar bien informado'
          }  
        ]
      },
      {
        id: 'DG',
        label: 'Deberes Generales',
        children: [
          {
            id: 'DOCONST',
            label: 'Deber de obedecer la constitución'
          },
          {
            id: 'DCL-N',
            label: 'Deber de Cumplimiento de las leyes y normas'
          },
          {
            id: 'DRP',
            label: 'Deber de respeto a la propiedad (privada/pública)'
          },
          {
            id: 'EVDC',
            label: 'Efecto vinculante de los derechos constitucionales'
          },
          {
            id: 'DAR',
            label: 'Deber de actuar responsablemente'
          },
          {
            id: 'DPF',
            label: 'Deber de protección a la familia'
          },
          {
            id: 'DESS',
            label: 'Deber del Estado de otorgar seguridad social'
          },
          {
            id: 'RM-EG',
            label: 'Respeto a la mujer y la equidad de género'
          },
          {
            id: 'DPAC',
            label: 'Deber de cada persona a su autocuidado'
          },
          {
            id: 'DP-CN-MA',
            label: 'Deberes de protección y conservación de la Naturaleza y del Medio ambiente'
          }
        ]
      },
      {
        id: 'DC-P',
        label: 'Derechos civiles y políticos',
        children: [
          {
            id: 'DDG-DC',
            label: 'Derecho a derrocar un gobierno ¿? Desobedencia civil'
          },
          {
            id: 'DFF',
            label: 'Derecho a formar una familia'
          },
          {
            id: 'DI',
            label: 'Derecho a la información'
          },
          {
            id: 'DFC',
            label: 'Derecho a formación cívica'
          },
          {
            id: 'DLA',
            label: 'Derecho a la libertad académica'
          },
          {
            id: 'DOC',
            label: 'Derecho a la objeción de conciencia'
          },
          {
            id: 'DPRIV',
            label: 'Derecho a la privacidad'
          },
          {
            id: 'DPPR',
            label: 'Derecho a proteger la propia reputación'
          },
          {
            id: 'DDP',
            label: 'Derecho al desarrollo de la personalidad'
          },
          {
            id: 'DM',
            label: 'Derecho al matrimonio'
          },
          {
            id: 'DPET',
            label: 'Derecho de petición'
          },
          {
            id: 'DPA',
            label: 'Derecho de portar armas'
          },
          {
            id: 'DERRC',
            label: 'Derecho de renunciar a la ciudadanía'
          },
          {
            id: 'DD',
            label: 'Derechos de los deudores'
          },
          {
            id: 'DME',
            label: 'Derechos de los menores de edad'
          },
          {
            id: 'DH',
            label: 'Dignidad humana'
          },
          {
            id: 'EPMC',
            label: 'Establece la posibilidad de matrimonio civil'
          },
          {
            id: 'LA',
            label: 'Libertad de asociación'
          },
          {
            id: 'LEXP',
            label: 'Libertad de expresión'
          },
          {
            id: 'LMOV',
            label: 'Libertad de movimiento'
          },
          {
            id: 'LOPC',
            label: 'Libertad de opinión/pensamiento/consciencia'
          },
          {
            id: 'LP',
            label: 'Libertad de prensa'
          },
          {
            id: 'LREU',
            label: 'Libertad de reunión'
          },
          {
            id: 'LRELIG',
            label: 'Libertad religiosa'
          },
          {
            id: 'LIBENS',
            label: 'Libertad de enseñanza'
          },
          {
            id: 'SU',
            label: 'Sufragio Universal'
          },
          {
            id: 'DECP',
            label: 'Derecho a ser elegido en cargos públicos'
          },
          {
            id: 'DERPART',
            label: 'Derecho a la participación '
          },
          {
            id: 'DPCRE',
            label: 'Derechos de las personas chilenas residentes en el extranjero'
          }  
        ]
      },
      {
        id: 'DE',
        label: 'Derechos Económicos',
        children: [
          {
            id: 'DCP',
            label: 'Derecho a contar con propiedades'
          },
          {
            id: 'DEO',
            label: 'Derecho a escoger una ocupación'
          },
          {
            id: 'DEN',
            label: 'Derecho a establecer un negocio'
          },
          {
            id: 'DMC',
            label: 'Derecho a un mercado competitivo'
          },
          {
            id: 'DTP',
            label: 'Derecho de transferencia de propiedad'
          },
          {
            id: 'EPI',
            label: 'Establece propiedad intelectual'
          },
          {
            id: 'PCE',
            label: 'Protección contra la expropiación'
          },
          {
            id: 'DICP',
            label: 'Derecho de Igualdad ante las cargas públicas'
          },
          {
            id: 'DLIE-LE',
            label: 'Derecho a Libre iniciativa económica / libre empresa'
          }  
        ]
      },
      {
        id: 'DP',
        label: 'Derechos procesales',
        children: [
          {
            id: 'DADJ',
            label: 'Derecho a apelar decisiones judiciales'
          },
          {
            id: 'DEET',
            label: 'Derecho a examinar evidencia/testigos'
          },
          {
            id: 'DJE',
            label: 'Derecho a juicios expeditos'
          },
          {
            id: 'DJP',
            label: 'Derecho a juicios públicos'
          },
          {
            id: 'DLDPP',
            label: 'Derecho a libertad durante la duración de un proceso penal'
          },
          {
            id: 'DABOG',
            label: 'Derecho a un abogado'
          },
          {
            id: 'DJJ',
            label: 'Derecho a un juicio justo'
          },
          {
            id: 'DAMP',
            label: 'Derecho de amparo'
          },
          {
            id: 'DAINATIV',
            label: 'Derecho del acusado a ser juzgado en su idioma nativo'
          },
          {
            id: 'GDP',
            label: 'Garantías de debido proceso'
          },
          {
            id: 'JO',
            label: 'Jurados obligatorios'
          },
          {
            id: 'PI',
            label: 'Presunción de inocencia'
          },
          {
            id: 'PNCSL',
            label: 'Principio de que no hay crimen sin ley'
          },
          {
            id: 'PMEPC',
            label: 'Privilegios para menores de edad en procesos criminales'
          },
          {
            id: 'PEXTRAD',
            label: 'Procedimiento de extradición'
          },
          {
            id: 'PJDVMC',
            label: 'Prohibición de juzgar dos veces por la misma causa'
          },
          {
            id: 'PCCI',
            label: 'Protección contra confinamiento injustificado'
          },
          {
            id: 'PCDA',
            label: 'Protección contra detención arbitraria'
          },
          {
            id: 'PCAI',
            label: 'Protección contra la auto-incriminación'
          },
          {
            id: 'PDV',
            label: 'Protección de derechos de las víctimas'
          },
          {
            id: 'PFLPF',
            label: 'Protección frente a leyes ex post facto'
          },
          {
            id: 'RPUBPRIS',
            label: 'Registro público de prisiones'
          },
          {
            id: 'RRE',
            label: 'Regulación de recolección de evidencia'
          }
        ]
      },
      {
        id: 'DS',
        label: 'Derechos Sociales',
        children: [
          {
            id: 'AES',
            label: 'Acceso a la Educación Superior'
          },
          {
            id: 'DEDUC',
            label: 'Derecho a la Educación'
          },
          {
            id: 'DS-PPC',
            label: 'Derecho a servicios y prestaciones públicas de calidad'
          },
          {
            id: 'AEAM',
            label: 'Apoyo estatal para adultos mayores'
          },
          {
            id: 'AED',
            label: 'Apoyo estatal para desempleados'
          },
          {
            id: 'AEME',
            label: 'Apoyo estatal para menores de edad'
          },
          {
            id: 'AEPD',
            label: 'Apoyo estatal para personas con discapacidades'
          },
          {
            id: 'DVD',
            label: 'Derecho a vivienda digna (reemplaza "Derecho a albergue" del CC)'
          },
          {
            id: 'DDO',
            label: 'Derecho a descanso y ocio'
          },
          {
            id: 'DDBC',
            label: 'Derecho a disfrutar los beneficios de la ciencia'
          },
          {
            id: 'DERHUELGA',
            label: 'Derecho a huelga'
          },
          {
            id: 'DIS',
            label: 'Derecho a igualdad salarial'
          },
          {
            id: 'DERSALUD',
            label: 'Derecho a la salud'
          },
          {
            id: 'DALS',
            label: 'Derecho a un ambiente laboral seguro'
          },
          {
            id: 'DERV',
            label: 'Derecho a un estándar razonable de vida'
          },
          {
            id: 'DERTRAB',
            label: 'Derecho al trabajo'
          },
          {
            id: 'DAS',
            label: 'Derecho de asociación a sindicatos'
          },
          {
            id: 'EDGRAT',
            label: 'Educación gratuita'
          },
          {
            id: 'EOB',
            label: 'Educación obligatoria'
          },
          {
            id: 'LREME',
            label: 'Límites relativos al empleo de menores de edad'
          },
          {
            id: 'PROTCON',
            label: 'Protección al consumidor'
          },
          {
            id: 'PPMA',
            label: 'Protección o preservación del medio ambiente'
          },
          {
            id: 'DAGUA',
            label: 'Derecho al agua (recursos hídricos)'
          },
          {
            id: 'DJD',
            label: 'Derecho a una jubilación digna'
          },
          {
            id: 'DCIUD',
            label: 'Derecho a la ciudad (equipamiento, planificación territorial, áreas verdes, servicios de calidad)'
          },
          {
            id: 'BANIM',
            label: 'Derecho del bienestar animal'
          },
          {
            id: 'DDIG',
            label: 'Derechos digitales'
          },
          {
            id: 'DAD-AF-R',
            label: 'Derecho de acceso al deporte, a la actividad física y a la recreación'
          },
          {
            id: 'DSS',
            label: 'Derecho a la seguridad social'
          },
        ]
      },
      {
        id: 'DIF',
        label: 'Derechos a la integridad física',
        children: [
          {
            id: 'DVIDA',
            label: 'Derecho a la vida'
          },
          {
            id: 'PCC',
            label: 'Prohibición de castigos corporales'
          },
          {
            id: 'PESC',
            label: 'Prohibición de la esclavitud'
          },
          {
            id: 'PPM',
            label: 'Prohibición de la pena de muerte'
          },
          {
            id: 'PT',
            label: 'Prohibición de la tortura'
          },
          {
            id: 'PTC',
            label: 'Prohibición de tratos crueles'
          },
          {
            id: 'DSVSV',
            label: 'Derecho a la seguridad/vida sin violencia'
          }  
        ]
      },
      {
        id: 'DIGM',
        label: 'Derechos de Igualdad, Género y Minoría',
        children: [
          {
            id: 'DERAUTO',
            label: 'Derecho a la autodeterminación'
          },
          {
            id: 'DERCULT',
            label: 'Derecho a la cultura'
          },
          {
            id: 'DERINDAG',
            label: 'Derechos de los indígenas a auto-gobierno'
          },
          {
            id: 'DERINDNPI',
            label: 'Derechos de los indígenas a no pagar impuestos'
          },
          {
            id: 'DERINDRESP',
            label: 'Derechos de los indígenas a ser representados'
          },
          {
            id: 'DERINDPP',
            label: 'Derechos de indígenas a partidos políticos'
          },
          {
            id: 'DERINDV',
            label: 'Derechos de los indígenas al voto'
          },
          {
            id: 'GGI',
            label: 'Garantía general de igualdad'
          },
          {
            id: 'IPCD',
            label: 'Igualdad de personas con discapacidades'
          },
          {
            id: 'IGMARIT',
            label: 'Igualdad marital'
          },
          {
            id: 'ISDCP',
            label: 'Igualdad sin distinción de color de piel'
          },
          {
            id: 'ISDE',
            label: 'Igualdad sin distinción de edad'
          },
          {
            id: 'ISDEF',
            label: 'Igualdad sin distinción de estatus financiero'
          },
          {
            id: 'ISDES',
            label: 'Igualdad sin distinción de estatus social'
          },
          {
            id: 'ISDFC',
            label: 'Igualdad sin distinción de fe o creencias'
          },
          {
            id: 'ISDGEN',
            label: 'Igualdad sin distinción de género'
          },
          {
            id: 'DERREPSEX',
            label: 'Derechos Reproductivos y sexuales'
          },
          {
            id: 'DMD',
            label: 'Derecho a una muerte digna '
          },
          {
            id: 'DDDS',
            label: 'De las Disidencias y diversidades sexuales'
          },
          {
            id: 'ISDIDIOM',
            label: 'Igualdad sin distinción de idioma'
          },
          {
            id: 'ISDNAC',
            label: 'Igualdad sin distinción de nacionalidad'
          },
          {
            id: 'ISDOS',
            label: 'Igualdad sin distinción de orientación sexual'
          },  
          {
            id: 'ISDOROG',
            label: 'Igualdad sin distinción de origen'
          },
          {
            id: 'ISDOF',
            label: 'Igualdad sin distinción de origen familiar'
          },
          {
            id: 'ISDPPOL',
            label: 'Igualdad sin distinción de partido político'
          },
          {
            id: 'ISDRAZA',
            label: 'Igualdad sin distinción de raza'
          },
          {
            id: 'ISDDR',
            label: 'Igualdad sin distinción de religión'
          },
          {
            id: 'ISDTCLAN',
            label: 'Igualdad sin distinción de tribu o clan'
          },
          {
            id: 'MCS',
            label: 'Menciones a la clase social'
          },
          {
            id: 'NGIND',
            label: 'Nacionalidad de los grupos indígenas'
          },
          {
            id: 'PPSP',
            label: 'Protección de personas sin patria'
          },
          {
            id: 'RDG',
            label: 'Restricciones a derechos de grupos'
          }
        ]
      },
      {
        id: 'EJEC',
        label: 'Ejecución',
        children: [
          {
            id: 'CDHUM',
            label: 'Comisión de derechos humanos'
          },
          {
            id: 'DAMPARO',
            label: 'Derecho de amparo'
          },
          {
            id: 'DINA',
            label: 'Derechos inalienables'
          },
          {
            id: 'Ombuds',
            label: 'Ombudsman'
          }  
        ]
      }
    ]
  },
  {
    id: 'POD-EJECT',
    label: 'Poder ejecutivo',
    children: [
      {
        id: 'EST-EJECT',
        label: 'Estructura del Ejecutivo',
        children: [
          {
            id: 'NEEJ',
            label: 'Nombre/estructura del(os) ejecutivo(s)'
          },
          {
            id: 'PG',
            label: 'Procurador general'
          },
          {
            id: 'RCGM',
            label: 'Reconocimiento constitucional del gabinete/ministros'
          },
          {
            id: 'VPM',
            label: 'Vicepresidente o Vice Primer Ministro'
          }
        ]
      },
      {
        id: 'FA',
        label: 'Fuerzas Armadas',
        children: [
          {
            id: 'ETM',
            label: 'Establecimiento de tribunales militares'
          },
          {
            id: 'FDG',
            label: 'Facultad de declarar la guerra'
          },
          {
            id: 'NJFA',
            label: 'Nombramiento del jefe de las fuerzas armadas'
          },
          {
            id: 'PEMERG',
            label: 'Provisiones de emergencia'
          },
          {
            id: 'RFA',
            label: 'Restricciones a las fuerzas armadas'
          },
          {
            id: 'RMD',
            label: 'Restricciones para ser ministro de defensa'
          },
          {
            id: 'SCSA',
            label: 'Selección de comandantes en servicio activo'
          },
          {
            id: 'SMILIT',
            label: 'Servicio militar'
          },
          {
            id: 'TERR',
            label: 'Terrorismo'
          }     
        ]
      },
      {
        id: 'GAB',
        label: 'Gabinete',
        children: [
          {
            id: 'FG',
            label: 'Facultades del gabinete'
          },
          {
            id: 'RCG',
            label: 'Reconocimiento constitucional del gabinete/ministros'
          },
          {
            id: 'REMGAB',
            label: 'Remoción del gabinete'
          },
          {
            id: 'RMG',
            label: 'Requisitos de los miembros del gabinete'
          },
          {
            id: 'SG',
            label: 'Selección del gabinete'
          }
        ]
      },
      {
        id: 'I-FE',
        label: 'Independencia y Facultades del Ejecutivo',
        children: [
          {
            id: 'DIE',
            label: 'Declaración de independencia del ejecutivo'
          },
          {
            id: 'FDJE',
            label: 'Facultad de decreto del jefe de estado'
          },
          {
            id: 'FDJG',
            label: 'Facultad de decreto del jefe de gobierno'
          },
          {
            id: 'FIND',
            label: 'Facultad de indulto'
          },
          {
            id: 'FGAB',
            label: 'Facultades del gabinete'
          },
          {
            id: 'FJE',
            label: 'Facultades del jefe de estado'
          },
          {
            id: 'FJG',
            label: 'Facultades del jefe de gobierno'
          },
          {
            id: 'IJG',
            label: 'Inmunidad del jefe de gobierno'
          },
          {
            id: 'LRJG',
            label: 'Límites para remover al jefe de gobierno'
          },
          {
            id: 'NOMJFA',
            label: 'Nombramiento del jefe de las fuerzas armadas'
          },
          {
            id: 'RG',
            label: 'Remoción del gabinete'
          },
          {
            id: 'RJE',
            label: 'Remoción del jefe de estado'
          },
          {
            id: 'RJG',
            label: 'Remoción del jefe de gobierno'
          },
          {
            id: 'RQMG',
            label: 'Requisitos de los miembros del gabinete'
          },
          {
            id: 'SLDE',
            label: 'Supervisión legislativa del ejecutivo'
          }
        ]
      },
      {
        id: 'JE',
        label: 'Jefe de Estado',
        children: [
          {
            id: 'DCJE',
            label: 'Duración del cargo de Jefe de Estado'
          },
          {
            id: 'EMJE',
            label: 'Edad mínima del jefe de estado'
          },
          {
            id: 'FDJEES',
            label: 'Facultad de decreto del jefe de estado'
          },
          {
            id: 'FJEST',
            label: 'Facultades del jefe de estado'
          },
          {
            id: 'IJE',
            label: 'Inmunidad del jefe de estado'
          },
          {
            id: 'LPJE',
            label: 'Límites a los periodos del jefe de estado'
          },
          {
            id: 'REMJE',
            label: 'Reemplazo del jefe de estado'
          },
          {
            id: 'REMOJE',
            label: 'Remoción del jefe de estado'
          },
          {
            id: 'RPSJE',
            label: 'Requisitos para ser Jefe de Estado'
          },
          {
            id: 'SELJE',
            label: 'Selección del Jefe de Estado'
          },
          {
            id: 'OCJE',
            label: 'Órganos consultivos del Jefe de Estado'
          }
        ]
      },
      {
        id: 'JG',
        label: 'Jefe de Gobierno',
        children: [
          {
            id: 'DCJG',
            label: 'Duración del cargo de Jefe de Gobierno'
          },
          {
            id: 'EMJG',
            label: 'Edad mínima del jefe de gobierno'
          },
          {
            id: 'FACDJG',
            label: 'Facultad de decreto del jefe de gobierno'
          },
          {
            id: 'FACJG',
            label: 'Facultades del jefe de gobierno'
          },
          {
            id: 'INMJG',
            label: 'Inmunidad del jefe de gobierno'
          },
          {
            id: 'LIMPJG',
            label: 'Límites a los periodos de jefe de gobierno'
          },
          {
            id: 'LIMRJG',
            label: 'Límites para remover al jefe de gobierno'
          },
          {
            id: 'REMJG',
            label: 'Reemplazo del jefe de gobierno'
          },
          {
            id: 'REMOJG',
            label: 'Remoción del jefe de gobierno'
          },
          {
            id: 'RQJG',
            label: 'Requisitos para ser Jefe de Gobierno'
          },
          {
            id: 'RJGL',
            label: 'Rol del jefe de gobierno en la legislatura'
          },
          {
            id: 'SJG',
            label: 'Selección del Jefe de Gobierno'
          }       
        ]
      }
    ]
  },
  {
    id: 'ELEC',
    label: 'Elecciones',
    children: [
      {
        id: 'N-PE',
        label: 'Normas y Procedimientos Electorales',
        children: [
          {
            id: 'Censos',
            label: 'Censos'
          },
          {
            id: 'DISTELECT',
            label: 'Distritos electorales'
          },
          {
            id: 'FINCAMP',
            label: 'Financiamiento de campañas'
          },
          {
            id: 'PELEC',
            label: 'Programación de elecciones'
          }
        ]
      },
      {
        id: 'PP',
        label: 'Partidos Políticos',
        children: [
          {
            id: 'DFPP',
            label: 'Derecho a formar partidos políticos'
          },
          {
            id: 'ISDPP',
            label: 'Igualdad sin distinción de partido político'
          },
          {
            id: 'PPPP',
            label: 'Partidos políticos predilectos/preferidos'
          },
          {
            id: 'PPP',
            label: 'Partidos políticos prohibidos'
          },
          {
            id: 'REGPP',
            label: 'Regulación de partidos políticos'
          },
          {
            id: 'RESPP',
            label: 'Restricciones a partidos políticos'
          }
        ]
      },
      {
        id: 'DPDA',
        label: 'Referendos e iniciativas',
        children: [
          {
            id: 'ILC',
            label: 'Iniciativas legislativas ciudadanas'
          },
          {
            id: 'REFE',
            label: 'Referéndum'
          }
        ]
      },
      {
        id: 'S-PE',
        label: 'Sufragio y Participación Electoral',
        children: [
          {
            id: 'DIVOT',
            label: 'Derechos de los indígenas al voto'
          },
          {
            id: 'RESVOT',
            label: 'Restricciones al voto'
          },
          {
            id: 'SUFUNI',
            label: 'Sufragio Universal'
          },
          {
            id: 'VOTBLIG',
            label: 'Voto obligatorio'
          }
        ]
      },
      {
        id: 'SE',
        label: 'Supervisión Electoral',
        children: [
          {
            id: 'COMELECT',
            label: 'Comisión electoral'
          },
          {
            id: 'DURJTE',
            label: 'Duración de un juez del Tribunal Electoral'
          },
          {
            id: 'EMJPTE',
            label: 'Edad mínima de los jueces que forman parte del Tribunal Electoral'
          },
          {
            id: 'FTELECT',
            label: 'Facultades del Tribunal Electoral'
          },
          {
            id: 'LPJTS',
            label: 'Límite a los periodos de los jueces en el Tribunal Electoral'
          },
          {
            id: 'REMOTE',
            label: 'Remoción del Tribunal Electoral'
          },
          {
            id: 'RJTELECT',
            label: 'Requisitos de los jueces del Tribunal Electoral'
          },
          {
            id: 'SMTELECT',
            label: 'Selección de los miembros del Tribunal Electoral'
          }
        ]
      }
    ]
  },
  {
    id: 'ENM',
    label: 'Enmienda',
    children: [
      {
        id: 'DCNSR',
        label: 'Disposiciones constitucionales no sujetas a reforma'
      },
      {
        id: 'PRC',
        label: 'Procedimiento de reforma constitucional'
      }
    ]
  },
  {
    id: 'ORG-EST',
    label: 'Organización del Estado',
    children: [
      {
        id: 'EE',
        label: 'Estructura del Estado',
        children: [
          {
            id: 'GOBMUNI',
            label: 'Gobierno municipal'
          },
          {
            id: 'UGS',
            label: 'Unidad gubernamental subsidiaria'
          },
          {
            id: 'DIVTERR',
            label: 'División territorial'
          },
          {
            id: 'FOREST',
            label: 'Forma de Estado: federalismo/ Autonomías regionales / Estado unitario'
          }
        ]
      },
      {
        id: 'FL',
        label: 'Facultad Legislativa',
        children: [
          {
            id: 'LN-SN',
            label: 'Legislación nacional vrs. sub-nacional'
          },
          {
            id: 'RFLSN',
            label: 'Revisión federal de legislación sub-nacional'
          }
        ]
      },
      {
        id: 'SA',
        label: 'Secesión y Anexión',
        children: [
          {
            id: 'ANXTERR',
            label: 'Anexión de territorio'
          },
          {
            id: 'SECTERR',
            label: 'Secesión de territorio'
          }
        ]
      }
    ]
  },
  {
    id: 'POD-JUD',
    label: 'Poder Judicial',
    children: [
      {
        id: 'A-FJ',
        label: 'Autonomía y Facultades del Judicial',
        children: [
          {
            id: 'CL',
            label: 'Constitucionalidad de legislación'
          },
          {
            id: 'EJFJ',
            label: 'Edad de jubilación forzosa de los jueces'
          },
          {
            id: 'FCS',
            label: 'Facultades de la Corte Suprema'
          },
          {
            id: 'FTC',
            label: 'Facultades del Tribunal Constitucional'
          },
          {
            id: 'IJ',
            label: 'Independencia judicial'
          },
          {
            id: 'IC',
            label: 'Interpretación constitucional'
          },
          {
            id: 'PJ',
            label: 'Precedente judicial'
          },
          {
            id: 'PSJ',
            label: 'Protección del salario de los jueces'
          },
          {
            id: 'RJCSO',
            label: 'Remoción de jueces de la corte Suprema/ordinaria'
          },
          {
            id: 'RJTC',
            label: 'Remoción de un juez del Tribunal Constitucional'
          }
        ]
      },
      {
        id: 'CS',
        label: 'Corte Suprema',
        children: [
          {
            id: 'DJCS',
            label: 'Duración de un juez de la Corte Suprema'
          },
          {
            id: 'EJFPCS',
            label: 'Edad mínima de los jueces que forman parte de la Corte Suprema'
          },
          {
            id: 'FCSUP',
            label: 'Facultades de la Corte Suprema'
          },
          {
            id: 'LPJCSUP',
            label: 'Límite a los periodos de los jueces en la Corte Suprema'
          },
          {
            id: 'OCS',
            label: 'Opiniones de la Corte Suprema'
          },
          {
            id: 'RJCS',
            label: 'Requisitos de los jueces de la Corte Suprema'
          },
          {
            id: 'SMCP',
            label: 'Selección de los miembros de la Corte Suprema'
          }
        ]
      },
      {
        id: 'EPJ',
        label: 'Estructura del Poder Judicial',
        children: [
          {
            id: 'ETA',
            label: 'Establecimiento de tribunales administrativos'
          },
          {
            id: 'ETECL',
            label: 'Establecimiento de tribunales eclesiásticos'
          },
          {
            id: 'ETL',
            label: 'Establecimiento de tribunales laborales'
          },
          {
            id: 'ETMILIT',
            label: 'Establecimiento de tribunales militares'
          },
          {
            id: 'ECJUD',
            label: 'Establecimiento de un consejo judicial'
          },
          {
            id: 'ETC',
            label: 'Establecimiento del Tribunal Constitucional'
          },
          {
            id: 'ETRIB',
            label: 'Estructura de los tribunales'
          },
          {
            id: 'TJSP',
            label: 'Tribunales para juzgar a servidores públicos'
          }
        ]
      },
      {
        id: 'RJ',
        label: 'Revisión Judicial',
        children: [
          {
            id: 'ADUV',
            label: 'Acciones administrativas ultra-vires'
          },
          {
            id: 'CLEGIS',
            label: 'Constitucionalidad de legislación'
          },
          {
            id: 'DERAMP',
            label: 'Derecho de amparo'
          },
          {
            id: 'INTC',
            label: 'Interpretación constitucional'
          }
        ]
      },
      {
        id: 'TC',
        label: 'Tribunal constitucional',
        children: [
          {
            id: 'DJTC',
            label: 'Duración de un juez del Tribunal Constitucional'
          },
          {
            id: 'EMJFTC',
            label: 'Edad mínima de los jueces que forman parte del Tribunal Constitucional'
          },
          {
            id: 'ESTTC',
            label: 'Establecimiento del Tribunal Constitucional'
          },
          {
            id: 'FACTC',
            label: 'Facultades del Tribunal Constitucional'
          },
          {
            id: 'LPJTC',
            label: 'Límite a los periodos de los jueces en el Tribunal Constitucional'
          },
          {
            id: 'OPTC',
            label: 'Opiniones del Tribunal Constitucional'
          },
          {
            id: 'RJTRIBC',
            label: 'Remoción de un juez del Tribunal Constitucional'
          },
          {
            id: 'RQJTC',
            label: 'Requisitos de los jueces del Tribunal Constitucional'
          },
          {
            id: 'SMTC',
            label: 'Selección de los miembros del Tribunal Constitucional'
          }
        ]
      },
      {
        id: 'TRIB-ELECT',
        label: 'Tribunal electoral',
        children: [
          {
            id: 'DJTEELECT',
            label: 'Duración de un juez del Tribunal Electoral'
          },
          {
            id: 'EDMINJTE',
            label: 'Edad mínima de los jueces que forman parte del Tribunal Electoral'
          },
          {
            id: 'FTTRIBE',
            label: 'Facultades del Tribunal Electoral'
          },
          {
            id: 'LPJTELECT',
            label: 'Límite a los periodos de los jueces en el Tribunal Electoral'
          },
          {
            id: 'REMTE',
            label: 'Remoción del Tribunal Electoral'
          },
          {
            id: 'REQJTE',
            label: 'Requisitos de los jueces del Tribunal Electoral'
          },
          {
            id: 'SELECTMTEL',
            label: 'Selección de los miembros del Tribunal Electoral'
          }
        ]
      },
      {
        id: 'TA',
        label: 'Tribunales administrativos',
        children: [
          {
            id: 'AADMUV',
            label: 'Acciones administrativas ultra-vires'
          },
          {
            id: 'DJTA',
            label: 'Duración de un juez de un tribunal administrativo'
          },
          {
            id: 'EDMINJTA',
            label: 'Edad mínima de los jueces que forman parte de tribunales administrativos'
          },
          {
            id: 'ETADM',
            label: 'Establecimiento de tribunales administrativos'
          },
          {
            id: 'LPJTA',
            label: 'Límite a los periodos de los jueces en tribunales administrativos'
          },
          {
            id: 'RJTA',
            label: 'Requisitos de los jueces de tribunales administrativos'
          },
          {
            id: 'SMTA',
            label: 'Selección de los miembros de tribunales administrativos'
          }
        ]
      },
      {
        id: 'TO',
        label: 'Tribunales ordinarios',
        children: [
          {
            id: 'DJTO',
            label: 'Duración de un juez de un tribunal ordinario'
          },
          {
            id: 'EMJTO',
            label: 'Edad mínima de los jueces que forman parte de los tribunales ordinarios'
          },
          {
            id: 'LPTO',
            label: 'Límite a los periodos de los jueces en tribunales ordinarios'
          },
          {
            id: 'RJTO',
            label: 'Requisitos de los jueces de tribunales ordinarios'
          },
          {
            id: 'SMTO',
            label: 'Selección de los miembros de tribunales ordinarios'
          }
        ]
      }
    ]
  },
  {
    id: 'POD-LEG',
    label: 'Poder Legislativo',
    children: [
      {
        id: 'D-S',
        label: 'Destitución y Sustitución',
        children: [
          {
            id: 'DESTLEG',
            label: 'Destitución de la legislatura'
          },
          {
            id: 'DLFI',
            label: 'Destitución de legisladores (de forma individual)'
          },
          {
            id: 'INMLEG',
            label: 'Inmunidad de legisladores'
          },
          {
            id: 'RLEG',
            label: 'Reemplazo de legisladores'
          }  
        ]
      },
      {
        id: 'ECL',
        label: 'Estructura de las cámaras legislativas',
        children: [
          {
            id: 'COMLEG',
            label: 'Comisiones legislativas'
          },
          {
            id: 'COMPER',
            label: 'Comisiones permanente'
          },
          {
            id: 'ESTRCL',
            label: 'Estructura de las cámaras legislativas'
          }
        ]
      },
      {
        id: 'I-FL',
        label: 'Independencia y Facultades del Legislativo',
        children: [
          {
            id: 'ALG',
            label: 'Aprobación de legislación general'
          },
          {
            id: 'DELEG',
            label: 'Destitución de la legislatura'
          },
          {
            id: 'DLFIND',
            label: 'Destitución de legisladores (de forma individual)'
          },
          {
            id: 'INLEG',
            label: 'Inmunidad de legisladores'
          },
          {
            id: 'PAV',
            label: 'Procedimiento de anulación de veto'
          },
          {
            id: 'REEMPLEG',
            label: 'Reemplazo de legisladores'
          }  
        ]
      },
      {
        id: 'LEG',
        label: 'Legislación',
        children: [
          {
            id: 'ALGEN',
            label: 'Aprobación de legislación general'
          },
          {
            id: 'DDTELC',
            label: 'División de trabajo entre las Cámaras'
          },
          {
            id: 'IDLG',
            label: 'Inicio de legislación general'
          },
          {
            id: 'PDADV',
            label: 'Procedimiento de anulación de veto'
          },
          {
            id: 'SMNPPL',
            label: 'Súper-mayoría necesaria para aprobar legislación'
          }  
        ]
      },
      {
        id: 'LE',
        label: 'Legislación Especial',
        children: [
          {
            id: 'LO',
            label: 'Leyes orgánicas'
          },
          {
            id: 'PECO',
            label: 'Planes económicos'
          },
          {
            id: 'PREEQ',
            label: 'Presupuesto equilibrado'
          },
          {
            id: 'PLG',
            label: 'Proyectos legislativos de gasto'
          },
          {
            id: 'PLF',
            label: 'Proyectos legislativos financieros'
          },
          {
            id: 'PLP',
            label: 'Proyectos legislativos presupuestarios'
          },
          {
            id: 'PLT',
            label: 'Proyectos legislativos tributarios'
          }  
        ]
      },
      {
        id: 'PC',
        label: 'Primera cámara',
        children: [
          {
            id: 'CRPC',
            label: 'Cuotas de representación en la primera cámara'
          },
          {
            id: 'DRPC',
            label: 'Duración de un representante de la primera cámara'
          },
          {
            id: 'EDRPC',
            label: 'Edad mínima de los representantes de la primera cámara'
          },
          {
            id: 'LPC',
            label: 'Líder de la primera cámara'
          },
          {
            id: 'LPRPC',
            label: 'Límite a los periodos de los representantes de la primera cámara'
          },
          {
            id: 'PRPC',
            label: 'Políticas reservadas para la primera cámara'
          },
          {
            id: 'RRPC',
            label: 'Requisitos de los representantes de la primera cámara'
          },
          {
            id: 'SRPC',
            label: 'Selección de los representantes de la primera cámara'
          },
          {
            id: 'TAMPC',
            label: 'Tamaño de la primera cámara'
          }
        ]
      },
      {
        id: 'R-RL',
        label: 'Reglas y Restricciones Legislativas',
        children: [
          {
            id: 'ADLL',
            label: 'Asistencia de los legisladores'
          },
          {
            id: 'DSL',
            label: 'Duración de sesiones legislativas'
          },
          {
            id: 'EEL',
            label: 'Empleos externos de los legisladores'
          },
          {
            id: 'PLE',
            label: 'Periodos legislativos extraordinarios'
          },
          {
            id: 'PD',
            label: 'Publicación de deliberaciones'
          },
          {
            id: 'QSL',
            label: 'Quórum de sesiones legislativas'
          },
          {
            id: 'REMLEG',
            label: 'Remuneración de los legisladores'
          },
          {
            id: 'RPLR',
            label: 'Requisito de publicidad de las remuneraciones'
          },
          {
            id: 'RCCL',
            label: 'Reunión conjunta de cámaras legislativas'
          },
          {
            id: 'SVL',
            label: 'Secreto del votos legislativo'
          },
          {
            id: 'SPP',
            label: 'Sesiones públicas o privadas'
          },
          {
            id: 'SLEGEJ',
            label: 'Supervisión legislativa del ejecutivo'
          }
        ]
      },
      {
        id: 'SC',
        label: 'Segunda cámara',
        children: [
          {
            id: 'CRSC',
            label: 'Cuotas de representación en la segunda cámara'
          },
          {
            id: 'DRSC',
            label: 'Duración de un representante de la segunda cámara'
          },
          {
            id: 'EMRSC',
            label: 'Edad mínima de los representantes de la segunda cámara'
          },
          {
            id: 'LSC',
            label: 'Líder de la segunda cámara'
          },
          {
            id: 'LPRSC',
            label: 'Límite a los periodos de los representantes de la segunda cámara'
          },
          {
            id: 'PRSC',
            label: 'Políticas reservadas para la segunda cámara'
          },
          {
            id: 'RRSC',
            label: 'Requisitos de los representantes de la segunda cámara'
          },
          {
            id: 'SRSC',
            label: 'Selección de los representantes de la segunda cámara'
          },
          {
            id: 'TSC',
            label: 'Tamaño de la segunda cámara'
          }
        ]
      }
    ]
  },
  {
    id: 'NOR-INT',
    label: 'Normas internacionales',
    children: [
      {
        id: 'POL-EXT',
        label: 'Política Exterior',
        children: [
          {
            id: 'FDECLG',
            label: 'Facultad de declarar la guerra'
          },
          {
            id: 'RREXT',
            label: 'Representante en relaciones exteriores'
          }
        ]
      },
      {
        id: 'REDI',
        label: 'Referencias Explícitas al Derecho Internacional',
        children: [
          {
            id: 'DINT',
            label: 'Derecho internacional'
          },
          {
            id: 'DIC',
            label: 'Derecho internacional consuetudinario'
          },
          {
            id: 'OI',
            label: 'Organizaciones internacionales'
          },
          {
            id: 'TIDH',
            label: 'Tratados internacionales de derechos humanos'
          }
        ]
      },
      {
        id: 'TRAT',
        label: 'Tratados',
        children: [
          {
            id: 'ELT',
            label: 'Estatus legal de los tratados'
          },
          {
            id: 'RT',
            label: 'Ratificación de tratados'
          },
          {
            id: 'TIDHUM',
            label: 'Tratados internacionales de derechos humanos'
          }
        ]
      }
    ]
  },
  {
    id: 'PRINCIP-SIMB',
    label: 'Principios y Símbolos',
    children: [
      {
        id: 'DE-S',
        label: 'Definición del Estado y Símbolos',
        children: [
          {
            id: 'BN',
            label: 'Bandera nacional'
          },
          {
            id: 'CNAC',
            label: 'Capital nacional'
          },
          {
            id: 'HN',
            label: 'Himno nacional'
          },
          {
            id: 'LNAC',
            label: 'Lema nacional'
          }
        ]
      },
      {
        id: 'PB',
        label: 'Principios Básicos',
        children: [
          {
            id: 'COL',
            label: 'Colonias'
          },
          {
            id: 'CRP',
            label: 'Crímenes del régimen previo'
          },
          {
            id: 'FAC',
            label: 'Fuente de autoridad constitucional'
          },
          {
            id: 'GR',
            label: 'Grupo(s) regionales'
          },
          {
            id: 'IP-PH',
            label: 'Intelectuales políticos y personajes históricos'
          },
          {
            id: 'JOC',
            label: 'Juramentos de obediencia a la constitución'
          },
          {
            id: 'MRC',
            label: 'Motivos para redactar la constitución'
          },
          {
            id: 'PRN',
            label: 'Propiedad de recursos naturales'
          },
          {
            id: 'RSP',
            label: 'Reclutamiento de servidores públicos'
          },
          {
            id: 'RFS',
            label: 'Referencia a la fraternidad/solidaridad'
          },
          {
            id: 'RHP',
            label: 'Referencia a la historia del país'
          },
          {
            id: 'RA',
            label: 'Referencia al arte'
          },
          {
            id: 'RC',
            label: 'Referencias a la ciencia'
          },
          {
            id: 'RDH',
            label: 'Referencias a los Derechos Humanos'
          },
          {
            id: 'RDEM',
            label: 'Referencias a la Democracia'
          },
          {
            id: 'REFJUS',
            label: 'Referencias a la Justicia'
          },
          {
            id: 'REFIGU',
            label: 'Referencias a la Igualdad'
          },
          {
            id: 'RRN-MA',
            label: 'Referencias al Respeto de la naturaleza o medio ambiente'
          },
          {
            id: 'RDA',
            label: 'Referencias a la Descentralización / Autonomía'
          },
          {
            id: 'RBC-C',
            label: 'Referencias al Bien común y a la Comunidad'
          },
          {
            id: 'RRESP',
            label: 'Referencias al Respeto'
          },
          {
            id: 'REFLIB',
            label: 'Referencias a la libertad '
          },
          {
            id: 'REFPART',
            label: 'Referencias a la Participación'
          },
          {
            id: 'REFINCL',
            label: 'Referencias a la Inclusión'
          },
          {
            id: 'REFSEG',
            label: 'Referencias a la Seguridad'
          },
          {
            id: 'REFMULTICULT',
            label: 'Referencias a la Multiculturalidad'
          },
          {
            id: 'RT-P',
            label: 'Referencias a la Transparencia y la publicidad'
          },
          {
            id: 'RDIV',
            label: 'Referencias a la Diversidad'
          },
          {
            id: 'REFSOB',
            label: 'Referencias a la Soberanía'
          },
          {
            id: 'REFROL',
            label: 'Referencias a la Tolerancia'
          },
          {
            id: 'REFDESA',
            label: 'Referencias al Desarrollo'
          },
          {
            id: 'REFIDCULT',
            label: 'Referencias a la Identidad cultural'
          },
          {
            id: 'REFCS',
            label: 'Referencias a la Cohesión social (equidad)'
          },
          {
            id: 'REFFAM',
            label: 'Referencias a la Familia'
          },
          {
            id: 'REFIC',
            label: 'Referencias a la Innovación y a la Creatividad'
          },
          {
            id: 'RAC', 
            label: 'Referencias a la Amistad Cívica'
          }
        ]
      }
    ]
  },
  {
    id: 'REG-SUPERV',
    label: 'Regulación y supervisión',
    children: [
      {
        id: 'ELECC',
        label: 'Elecciones',
        children: [
          {
            id: 'COM-ELECT',
            label: 'Comisión electoral'
          },
          {
            id: 'DJTE',
            label: 'Duración de un juez del Tribunal Electoral'
          },
          {
            id: 'EMJTE',
            label: 'Edad mínima de los jueces que forman parte del Tribunal Electoral'
          },
          {
            id: 'FTE',
            label: 'Facultades del Tribunal Electoral'
          },
          {
            id: 'LPJTE',
            label: 'Límite a los periodos de los jueces en el Tribunal Electoral'
          },
          {
            id: 'RPP',
            label: 'Regulación de partidos políticos'
          },
          {
            id: 'RTE',
            label: 'Remoción del Tribunal Electoral'
          },
          {
            id: 'RJTE',
            label: 'Requisitos de los jueces del Tribunal Electoral'
          },
          {
            id: 'SMTE',
            label: 'Selección de los miembros del Tribunal Electoral'
          }  
        ]
      },
      {
        id: 'MC',
        label: 'Medios de comunicación',
        children: [
          {
            id: 'CT',
            label: 'Comisión de telecomunicaciones'
          },
          {
            id: 'OEM',
            label: 'Operación estatal de los medios'
          },
          {
            id: 'Radio',
            label: 'Radio'
          },
          {
            id: 'TELECO',
            label: 'Telecomunicaciones (Incluye Internet y redes)'
          },
          {
            id: 'TV',
            label: 'Televisión'
          },
          {
            id: 'Internet',
            label: 'Internet'
          }
        ]
      },
      {
        id: 'AS',
        label: 'Asuntos sociales',
        children: [
          {
            id: 'DA-SI',
            label: 'Drogas, alcohol y sustancias ilegales'
          }
        ]
      },
      {
        id: 'OA-C',
        label: 'Órganos Autónomos y Comisiones',
        children: [
          {
            id: 'BC',
            label: 'Banco central'
          },
          {
            id: 'C-AC',
            label: 'Comisión anti-corrupción'
          },
          {
            id: 'CDH',
            label: 'Comisión de derechos humanos'
          },
          {
            id: 'CTELEC',
            label: 'Comisión de telecomunicaciones'
          },
          {
            id: 'CV-R',
            label: 'Comisión de verdad y reconciliación'
          },
          {
            id: 'CE',
            label: 'Comisión electoral'
          },
          {
            id: 'ECJ',
            label: 'Establecimiento de un consejo judicial'
          },
          {
            id: 'Ombudsman',
            label: 'Ombudsman'
          },
          {
            id: 'CG-TC',
            label: 'Contraloría General/Tribunales de Cuentas'
          },
          {
            id: 'MP-DP',
            label: 'Ministerio Público/Defensoría Pública'
          },
          {
            id: 'SII',
            label: 'Servicio de Impuestos Internos'
          }          
        ]
      }
    ]
  },
  {
    id: 'SEC-ESP',
    label: 'Secciones especiales',
    children: [
      {
        id: 'DT',
        label: 'Disposiciones transitorias'
      },
      {
        id: 'PRMBL',
        label: 'Preámbulo'
      }
    ]
  },
];

export default ontology;
